<template>
  <gc-main-layout :title="title" :isXSmall="isXSmall" :isLarge="isLarge">
    <div class="content home">
      <!-- <h2 class="content-block">Home</h2> -->
      <div class="content-block home-content" ref="home-content">
        <div class="title-div">
          <span class="title"
            >Hi <span class="name">{{ userName }}</span></span
          >
        </div>
        <img
          class="home-img"
          src="../assets/images/home-image.png"
          width="400"
        />
        <div class="details-div">
          <span class="welcome"
            >Welcome to GCORP<span class="version">cx</span></span
          >
          <p class="p-details">
            The key to delivering operational success and excellence.
          </p>
        </div>
      </div>
    </div>
  </gc-main-layout>
</template>
<script>
import appConfig from "../app-config";

import BaseViewMixin from "../v1/_mixins/base.view";
import { UserService } from "../_services/api/settings/user/user.service";
import { UserStorage } from "../_services/storage";

export default {
  props: {},
  data() {
    return {
      tabs: [],
      selectedIndex: 0,
      userName: null,
    };
  },

  mixins: [BaseViewMixin],
  async created() {
    var userFirstName = UserStorage.getItems(
      `UserFirstName_${appConfig.VUE_APP_COOKIE_NAME}`
    );
    this.userName =
      userFirstName == "" || userFirstName == null || userFirstName == undefined
        ? UserService.getUsername()
        : userFirstName;
      
    this.$store.dispatch("defaultDateSettings/setCurrentFiscalData");
  },
};
</script>

<style lang="scss">
.content.home{
  background-color: white;
}
</style>
